













































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import LeafletImageComponent from "@/components/packages/leaflet/LeafletImageComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import SensorDefaultSettingComponent from "./components/SensorDefaultSettingComponent.vue";
import SensorMenuModalComponent from "./components/SensorMenuModalComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { Sensor } from "@/typescript/models/sensor/types";
import { storeMenus } from "@/config/store_menus";
import { DiagramsSize } from "@/typescript/pages/sensor_diagrams/index";
import { getRoutePath } from "@/router/routes";
import { SensorDiagramsInfo } from "@/typescript/pages/sensor_diagrams/types";
import { getEquipmentsMeasurementApi } from "@/typescript/api_client/emesh_api/equipments/equipments_measurement_api";
import { getEquipmentsApi } from "@/typescript/api_client/emesh_api/equipments/equipments_api";
import { getStoreSensorsApi } from "../../typescript/api_client/emesh_api/stores/store_sensors_api";
import { getDiagramApi } from "@/typescript/api_client/emesh_api/stores/diagram_api";
//import { getImage } from "@/typescript/lib/common/get_image";
import { getDiagramImageApi } from "@/typescript/api_client/emesh_api/stores/diagram_image_api";
import { convertPdf } from "@/typescript/lib/common/convert_pdf";
import { AlertData } from "@/typescript/lib/common/types";
import { getAlertData } from "@/typescript/lib/common/get_alert_data";
import { postEquipmentsPositionApi } from "@/typescript/api_client/emesh_api/equipments/equipments_position_api";
import SaveDialogComponent from "@/components/common/parts/SaveDialogComponent.vue";
import { fillZero } from "@/typescript/lib/common/fill_zero";
import { GetStoreSensorsResponse } from "../../typescript/api_client/emesh_api/stores/types";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
export {
  DiagramsSize,
  Sensor,
  SensorDiagramsInfo,
  AlertData,
  GetStoreSensorsResponse
};

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    LeafletImageComponent,
    ButtonComponent,
    SensorDefaultSettingComponent,
    SensorMenuModalComponent,
    SaveDialogComponent,
    ConfirmDialogComponent,
    FooterComponent
  }
})
export default class SensorDiagramsEditPage extends Vue {
  $refs!: {
    drawingArea: Element;
    canvas: any;
  };
  bounds = this.getDiagramsSize().bounds;

  sensorDiagramsInfos: SensorDiagramsInfo[] = [];
  rawSensorDiagramsInfos: SensorDiagramsInfo[] = [];
  // ユーザーが選択することができるセンサ一覧を格納する

  // 設定値があるセンサ情報を格納する
  mappingSensors: SensorDiagramsInfo[] = [];
  storeDiagramImage: string = "";
  diagramId: number = 0;

  isDisplayDialog: boolean = false;
  dialogMsg: string = "";
  removeSensors: SensorDiagramsInfo[] = [];
  isConfirmDialogOpen: boolean = false;

  // 店舗図を表示するエリアを計算した値を返却する
  calcDiagramsSize(height: number, width: number) {
    return {
      bounds: [
        [0, 0],
        [height, width]
      ]
    };
  }

  // 店舗図を表示するエリアの値を返却する
  getDiagramsSize() {
    // 境界値の設定はアップロードされる画像サイズに合わせて変更する必要がある
    return this.calcDiagramsSize(500, 1200);
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  removeMappingSensors(sensor: SensorDiagramsInfo) {
    this.removeSensors.push(sensor);
    this.setMappingSensors(
      this.mappingSensors.filter(s => s.equipmentId !== sensor.equipmentId)
    );
  }

  setMappingSensors(sensors: SensorDiagramsInfo[]) {
    this.mappingSensors = sensors;
    this.setSelectableSensors();
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    // this.$router.push(
    //   getRoutePath("MasterManagementsPage", {
    //     store_id: this.$route.params.store_id
    //   })
    // );

    this.$store.commit("setSensorsTabName", {
      sensorsTabName: "センサ配置図"
    });
    this.$router.push(
      getRoutePath("SensorsShowPage", {
        store_id: this.$route.params.store_id
      })
    );
  }

  pushMappingSensors(reSensor: SensorDiagramsInfo[]) {
    if (reSensor === null) return;
    this.setMappingSensors(reSensor);
  }

  get internalMappingSensors(): SensorDiagramsInfo[] {
    return this.mappingSensors;
  }

  async setStoreImagePath() {
    const diagrams = await getDiagramApi(this.$route.params.store_id);
    const storeDiagram = diagrams.find(d => d.diagram_id === this.diagramId);
    if (!storeDiagram) return "";
    //this.storeDiagramImage = storeDiagram.url;

    //const resp = await getImage(storeDiagram.url);
    const resp = await getDiagramImageApi(storeDiagram.diagram_id);

    if (resp.headers["content-type"] === "application/pdf") {
      const png = await convertPdf(resp.data, this.$refs.canvas);
      this.storeDiagramImage = png;
      return;
    } else {
      const file = new File([resp.data], "image", {
        type: resp.headers["content-type"]
      });
      //const file = resp.data;
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          // 画像ファイルを base64 文字列に変換
          if (typeof reader.result === "string")
            this.storeDiagramImage = reader.result;
        },
        false
      );
      reader.readAsDataURL(file);
    }
  }

  setSensorDiagramsInfos() {
    this.makeSensorDiagramsInfos().then(resp => {
      this.rawSensorDiagramsInfos = resp as SensorDiagramsInfo[];
      this.mappingSensors = resp.filter(
        // センサ配置されていない場合は 0 がセットされるため、0 以外を条件とする
        s => s.positionX !== 0 && s.positionY !== 0
      ) as SensorDiagramsInfo[];
      this.setSelectableSensors();
    });
  }

  async getSensorData(
    equipmentId: string
  ): Promise<{
    temperature: string;
    alertStatus: number;
    alerts: AlertData[];
    battery: number | null;
    receiveBLESensitivity: number | null;
  }> {
    return await getEquipmentsMeasurementApi({
      equipment_id: equipmentId
    }).then(resp => {
      const temperature = resp.measurement_data[0]
        ? resp.measurement_data[0].temperature
        : "--";
      const battery = resp.measurement_data[0]
        ? resp.measurement_data[0].battery
        : null;
      const recieveSensitivity = resp.measurement_data[0]
        ? resp.measurement_data[0].receive_sensitivity
        : null;
      return {
        temperature: temperature,
        alerts: resp.alerts.map(a =>
          getAlertData(a.alert_id, resp.status as 0 | 1 | 2)
        ),
        alertStatus: resp.status,
        battery: battery,
        // null の場合はアイコンを without にしたいため、 -100 を代入する
        receiveBLESensitivity:
          recieveSensitivity === null
            ? -100
            : resp.measurement_data[0].receive_sensitivity
      };
    });
  }

  async getEquipment(
    equipmentId: string
  ): Promise<{
    iconKind: number;
    guardTime: number;
    serialNo: string;
    snoozingTime: number;
    locationNo: string;
  }> {
    return await getEquipmentsApi(equipmentId).then(resp => {
      return {
        iconKind: resp.icon_kind,
        guardTime: resp.guard_time,
        serialNo: resp.serial_no,
        snoozingTime: resp.snoozing_time,
        locationNo:
          resp.location_no === null ? "00" : fillZero(resp.location_no, 2)
      };
    });
  }

  async makeSensorDiagramsInfos() {
    const storeSensors = await getStoreSensorsApi(
      this.$route.params.store_id
    ).then((resp: GetStoreSensorsResponse) => {
      return resp;
    });
    storeSensors.sensors.sort(
      (a, b) => Number(a.location_no) - Number(b.location_no)
    );

    return Promise.all(
      storeSensors.sensors.map(async sensor => {
        const sensorData = await this.getSensorData(sensor.equipment_id);
        const equipment = await this.getEquipment(sensor.equipment_id);

        if (sensorData.receiveBLESensitivity === null) {
          // null の場合はアイコンを without にしたいため、 -100 を代入する
          sensorData.receiveBLESensitivity = -100;
        }

        if (sensorData.battery === null) {
          sensorData.battery = 0;
        }

        return {
          alertStatus: sensorData.alertStatus,
          alerts: sensorData.alerts,
          battery: sensorData.battery,
          equipmentId: sensor.equipment_id,
          equipmentName: sensor.equipment_name,
          guardTime: equipment.guardTime,
          iconKind: equipment.iconKind,
          lowerLimit: sensor.lower_limit,
          receiveBLESensitivity: sensorData.receiveBLESensitivity,
          serialNo: equipment.serialNo,
          snoozingTime: equipment.snoozingTime,
          temperature: sensorData.temperature,
          upperLimit: sensor.upper_limit,
          positionX: sensor.position_x,
          positionY: sensor.position_y,
          locationNo: equipment.locationNo
        };
      })
    );
  }

  created() {
    this.$store.commit("setActiveId", {
      //activeId: storeMenus().find(m => m.pageName === "MasterManagementsPage")
      activeId: storeMenus().find(m => m.pageName === "SensorsShowPage")?.id
    });
    const queries = this.$route.query;
    if ("diagram_id" in queries && queries.diagram_id !== "") {
      this.diagramId = Number(queries.diagram_id);
    }
    this.setStoreImagePath();
    this.setSensorDiagramsInfos();
  }

  setSelectableSensors() {
    this.sensorDiagramsInfos = this.rawSensorDiagramsInfos.map(s => {
      s.selected = this.mappingSensors.some(
        ms => ms.equipmentId === s.equipmentId
      );
      return s;
    });
  }

  mappingSensor(sensor: SensorDiagramsInfo) {
    this.mappingSensors.push(sensor);
    // センサが移動した際に設置済みセンサが加算されないように重複をチェックし、取り除く
    this.mappingSensors = this.mappingSensors.filter((s, index, self) => {
      return (
        self.findIndex(s2 => {
          return s.equipmentId === s2.equipmentId;
        }) === index
      );
    });
    this.setSelectableSensors();
  }

  save() {
    this.removeSensors.forEach(rs => {
      postEquipmentsPositionApi({
        equipment_id: rs.equipmentId,
        position_x: 0,
        position_y: 0
      });
    });
    Promise.all(
      this.mappingSensors.map(async ms => {
        return await postEquipmentsPositionApi({
          equipment_id: ms.equipmentId,
          position_x: ms.positionX,
          position_y: ms.positionY
        }).then(resp => {
          return resp;
        });
      })
    )
      .then(() => {
        this.isDisplayDialog = true;
        this.dialogMsg = "センサ配置を保存しました";
      })
      .catch(() => {
        this.isDisplayDialog = true;
        this.dialogMsg = "保存に失敗しました";
      });
  }

  onClickOk() {
    this.isDisplayDialog = false;
  }
}
